import React, { useState } from 'react';
import Carousel from 'nuka-carousel';
import _isBoolean from 'lodash/isBoolean';
import { IconButton } from 'wix-style-react';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import ChevronLeft from 'wix-ui-icons-common/ChevronLeft';
import expertPropType from '../../../common/prop-types/expertPropType';
import ExpertBaseDetails from '../../../common/ExpertBaseDetails/ExpertBaseDetails';
import PortfolioItem from '../../../common/PortfolioItem/PortfolioItem';
import expertLocation from '../../../../utils/expertLocationFormatter';
import s from './expertsListItem.scss';
import isServer from '../../../../utils/isServer';
import PriceCta from './PriceCta';
import ViewProfileCta from './ViewProfileCta';
import { connect } from 'react-redux';
import { experimentsSelectors } from '@wix/wix-experiments-redux';

const mapStateToProps = ({ experiments }) => ({
  enableNewArenaExplorePageContent: experimentsSelectors({
    experiments,
  }).enabled('specs.experts.ArenaExplorePageContent'),
});

const ExpertsListItem = props => {
  const {
    expert,
    onClick,
    onMinimalPriceClick,
    staticsBaseUrl,
    enableNewArenaExplorePageContent,
  } = props;
  const [enableKeyboardControls, setEnableKeyboardControls] = useState(false);
  const slideWidth = 295;
  const slidesToShow = isServer ? 5 : (window.innerWidth - 554) / slideWidth;

  return (
    <div className={s.root} data-hook="expert-item">
      <div className={s.expertInfo}>
        <ExpertBaseDetails
          key={expert.id}
          id={expert.id}
          name={expert.name}
          username={expert.username}
          profilePhoto={expert.profilePhoto}
          shortDescription={expert.description}
          reviewsScore={expert.reviewsScore}
          totalReviews={expert.totalReviews}
          totalProjects={expert.totalProjects}
          showProjects={true}
          location={expertLocation(expert.location)}
          horizontalLayout={true}
          onClick={onClick}
        />
        <div className={s.cta}>
          {enableNewArenaExplorePageContent ? (
            <ViewProfileCta
              onClick={onClick}
              id={expert.id}
              username={expert.username}
              reviewsScore={expert.reviewsScore}
            />
          ) : (
            <PriceCta
              expert={expert}
              onClick={() => onMinimalPriceClick(expert)}
            />
          )}
        </div>
      </div>
      <div
        className={s.portfolioCatalog}
        tabIndex={0}
        onFocus={() => {
          setEnableKeyboardControls(true);
        }}
        onBlur={() => {
          setEnableKeyboardControls(false);
        }}
      >
        <Carousel
          enableKeyboardControls={enableKeyboardControls}
          slideWidth={`${slideWidth}px`}
          initialSlideHeight={166}
          slidesToShow={slidesToShow}
          slidesToScroll="auto"
          cellSpacing={30}
          cellAlign="left"
          renderBottomCenterControls={() => {}}
          renderCenterLeftControls={({ previousSlide, currentSlide }) => (
            <IconButton
              className={`${s.carouselLeftControl} ${
                currentSlide === 0 ? s.carouselControlDisabled : ''
              }`}
              as="button"
              onClick={previousSlide}
              skin="inverted"
              priority="secondary"
            >
              <ChevronLeft />
            </IconButton>
          )}
          renderCenterRightControls={({ nextSlide, currentSlide }) => (
            <IconButton
              className={`${s.carouselRightControl} ${
                currentSlide > expert.portfolio.length - slidesToShow
                  ? s.carouselControlDisabled
                  : ''
              }`}
              as="button"
              onClick={nextSlide}
              skin="inverted"
              priority="secondary"
            >
              <ChevronRight />
            </IconButton>
          )}
          style={{ height: 166 }}
        >
          {expert.portfolio
            .filter(
              item =>
                !_isBoolean(item.visibility) ||
                (_isBoolean(item.visibility) && item.visibility),
            )
            .map((project, index) => (
              <div
                style={{
                  cursor: project.url ? 'pointer' : 'default',
                }}
                key={index}
              >
                <PortfolioItem
                  siteUrl={project.url}
                  className={s.projectItemContainer}
                  siteName={project.siteName}
                  description={project.projectDescription}
                  thumbnail={project.thumbnailUrl}
                  uploadImage={project.uploadImage}
                  imgDimensions={{ w: 259, h: 154 }}
                  expertGuid={expert.id}
                  siteLocationId={index}
                  origin="explore page"
                  metaSiteId={project.metaSiteId}
                  staticsBaseUrl={staticsBaseUrl}
                />
              </div>
            ))}
        </Carousel>
      </div>
    </div>
  );
};

ExpertsListItem.propTypes = {
  expert: expertPropType,
};

export default connect(mapStateToProps, {})(ExpertsListItem);
